import React from 'react';
import { Route } from 'react-router-dom';
import ListConceptos from './Components/ListConceptos';
import ConceptoNew from './Components/ConceptoNew';


export default class AdmConceptos extends React.Component {

  render() {
    return (
      <div>
        <Route exact path="/Conceptos" component={ListConceptos}/>
        <Route exact path="/Conceptos/Nuevo" component={ConceptoNew}/>
      </div>
    );
  }
}